module.exports = __webpack_public_path__ + "img/bim (2).388638ea.png";